import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function WhyArmenia() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const reasons = [
    { icon: 'ri-building-2-line', title: t('whyArmenia.r1.title'), desc: t('whyArmenia.r1.desc') },
    { icon: 'ri-coins-line', title: t('whyArmenia.r2.title'), desc: t('whyArmenia.r2.desc') },
    { icon: 'ri-map-pin-line', title: t('whyArmenia.r3.title'), desc: t('whyArmenia.r3.desc') },
    { icon: 'ri-global-line', title: t('whyArmenia.r4.title'), desc: t('whyArmenia.r4.desc') },
    { icon: 'ri-home-smile-line', title: t('whyArmenia.r5.title'), desc: t('whyArmenia.r5.desc') },
    { icon: 'ri-shield-check-line', title: t('whyArmenia.r6.title'), desc: t('whyArmenia.r6.desc') },
  ];

  return (
    <section className="py-24" style={{ backgroundColor: '#F8F9FB' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div className="lg:sticky lg:top-28">
            <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase mb-4 block">{t('whyArmenia.badge')}</span>
            <h2 className="text-4xl font-bold text-gray-900 leading-tight mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('whyArmenia.title')}
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              {t('whyArmenia.desc1')}
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              {t('whyArmenia.desc2')}
            </p>
            <div className="rounded-2xl overflow-hidden" style={{ height: 260 }}>
              <img
                src="https://public.readdy.ai/ai/img_res/ab31c87f61fb83dfd3f6aacf34e97726.jpg"
                alt="Yerevan, Armenia"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <button
              onClick={() => navigate('/contact')}
              className="whitespace-nowrap inline-flex items-center gap-2 mt-8 border border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-medium px-7 py-3.5 rounded-full transition-all duration-200 text-sm cursor-pointer"
            >
              {t('whyArmenia.cta')} <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* Right: grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {reasons.map((reason) => (
              <div
                key={reason.title}
                className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-blue-200 transition-all duration-200 cursor-default"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-xl mb-4">
                  <i className={`${reason.icon} text-blue-600 text-lg`}></i>
                </div>
                <h4 className="text-sm font-semibold text-gray-900 mb-2">{reason.title}</h4>
                <p className="text-xs text-gray-500 leading-relaxed">{reason.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
